import React from "react";
import { Tab, TabList, TabPanel, Tabs, TabPanels } from "@chakra-ui/react";
import { useSelector } from "react-redux";
import CorporateModalInfo from "./CorporateModalInfo";
import CorporateDirModal from "./CorporateDirModal";
import CorporateRefeeModal from "./CorporateRefeeModal";
import CorporateDocuploadModal from "./CorporateDocuploadModal";

const CorporateDetails = () => {
  const corporateDetails = useSelector((state) => state.modal.formModal?.data);
  return (
    <>
      <Tabs variant="unstyled" pt={5}>
        <TabList
          gap={"20px"}
          pb={4}
          sx={{
            overflowY: "scroll",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
            "-ms-overflow-style": "none",
            "&::-webkit-scrollbar": {
              display: "none",
            },
          }}
          overflowY={"auto"}
        >
          <Tab
            _selected={{ color: "#FFFFFF", bg: "#23A455CC" }}
            lineHeight={"16.41px"}
            whiteSpace="nowrap"
            p={"15px"}
            bg={"#E9E9E9"}
            w={["100%", "40%", "40%", "40%"]}
            borderRadius={"4px"}
            letterSpacing={"-0.25px"}
            color={"#54595F"}
          >
            Organization Details
          </Tab>
          <Tab
            _selected={{ color: "#FFFFFF", bg: "#23A455CC" }}
            lineHeight={"16.41px"}
            whiteSpace="nowrap"
            p={"15px"}
            bg={"#E9E9E9"}
            w={["100%", "40%", "40%", "40%"]}
            borderRadius={"4px"}
            letterSpacing={"-0.25px"}
            color={"#54595F"}
          >
            Directors & Owners

          </Tab>
          <Tab
            _selected={{ color: "#FFFFFF", bg: "#23A455CC" }}
            lineHeight={"16.41px"}
            whiteSpace="nowrap"
            p={"15px"}
            bg={"#E9E9E9"}
            w={["100%", "40%", "40%", "40%"]}
            borderRadius={"4px"}
            letterSpacing={"-0.25px"}
            color={"#54595F"}
          >
            Referee Info
          </Tab>
          <Tab
            _selected={{ color: "#FFFFFF", bg: "#23A455CC" }}
            lineHeight={"16.41px"}
            whiteSpace="nowrap"
            p={"15px"}
            bg={"#E9E9E9"}
            w={["100%", "40%", "40%", "40%"]}
            borderRadius={"4px"}
            letterSpacing={"-0.25px"}
            color={"#54595F"}
          >
            Documents Upload
          </Tab>
        </TabList>

        <TabPanels bg={"#FFFFFF"}>
          <TabPanel>
            <CorporateModalInfo corporateDetails={corporateDetails} />
          </TabPanel>
          <TabPanel>
            <CorporateDirModal corporateDetails={corporateDetails} />
          </TabPanel>
          <TabPanel>
            <CorporateRefeeModal corporateDetails={corporateDetails} />
          </TabPanel>
          <TabPanel>
            <CorporateDocuploadModal corporateDetails={corporateDetails} />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </>
  );
};

export default CorporateDetails;
